module.exports = __webpack_public_path__ + "static/media/3DPPA14.96b5cdce.jpg";